import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Params } from '@angular/router';
import * as onboardingActions from '@store/onboarding/onboarding.actions';
import * as onboardingSelectors from '@store/onboarding/onboarding.selectors';
import { IKycApplication } from '../core/models/onboarding.model';

import {
  IOnboardingKYC,
  IOnboardingParams,
  IOnboardingSession,
} from '../core/models/onboarding.model';

@Injectable({ providedIn: 'root' })
export class OnboardingFacade {
  public information$: Observable<IOnboardingSession>;
  public auth10tix$: Observable<IOnboardingKYC>;
  public isLoading$: Observable<boolean>;
  public error$: Observable<boolean>;
  public customerValidation$: Observable<boolean>;
  public stepInfo$: Observable<IOnboardingParams>;
  public stepTwoInfo$: Observable<IOnboardingParams>;
  public customerExists$: Observable<boolean>;
  public customerBlockedByMultipleAttempts$: Observable<boolean>;
  public onboardingStep$: Observable<number>;
  public isPostLoading$: Observable<boolean>;

  constructor(private _store: Store) {
    this.information$ = this._store.select(onboardingSelectors.selectInformation);
    this.isLoading$ = this._store.select(onboardingSelectors.selectIsLoading);
    this.auth10tix$ = this._store.select(onboardingSelectors.selectAuth10tix);
    this.error$ = this._store.select(onboardingSelectors.selectIsError);
    this.customerValidation$ = this._store.select(onboardingSelectors.selectCustomerValidation);
    this.stepInfo$ = this._store.select(onboardingSelectors.selectStepInfo);
    this.stepTwoInfo$ = this._store.select(onboardingSelectors.selectStepTwoInfo);
    this.customerExists$ = this._store.select(onboardingSelectors.selectCustomerExists);
    this.customerBlockedByMultipleAttempts$ = this._store.select(
      onboardingSelectors.selectCustomerBlockedByMultipleAttempts
    );
    this.onboardingStep$ = this._store.select(onboardingSelectors.selectOnboardingStep);
    this.isPostLoading$ = this._store.select(onboardingSelectors.selectIsPostLoading);
  }

  public requestOnboardingSession(step: number) {
    this._store.dispatch(onboardingActions.requestOnboardingSession({ step }));
  }

  public successRequestOnboardingSession(information: IOnboardingSession) {
    this._store.dispatch(onboardingActions.successRequestOnboardingSession({ information }));
  }

  public saveOnboardingStep(stepInfo: IOnboardingParams) {
    this._store.dispatch(onboardingActions.saveOnboardingStep({ stepInfo }));
  }

  public saveAuth10tixStatus() {
    this._store.dispatch(onboardingActions.saveAuth10tixStatus());
  }

  public requestAuth10tixStatus() {
    this._store.dispatch(onboardingActions.requestAuth10tixStatus());
  }

  public setKYCApplication(application: IKycApplication | Params) {
    this._store.dispatch(onboardingActions.setKYCApplication({ application }));
  }

  public listentAuth10tixStatus() {
    this._store.dispatch(onboardingActions.listentAuth10tixStatus());
  }

  public successAuth10tixStatuss(auth10tix: IOnboardingKYC) {
    this._store.dispatch(onboardingActions.successRequestAuth10tixStatus({ auth10tix }));
  }

  public getPreCustomer() {
    this._store.dispatch(onboardingActions.getPreCustomer());
  }
  // DEMO
  public setUnderReviewAuth10tixStatus(status: number) {
    this._store.dispatch(onboardingActions.setUnderReviewAuth10tixStatus({ status }));
  }

  public setCustomerExists(value: boolean): void {
    this._store.dispatch(onboardingActions.setCustomerExists({ value: value }));
  }

  public setCustomerBlockedByMultipleAttempts(value: boolean): void {
    this._store.dispatch(onboardingActions.setCustomerBlockedByMultipleAttempts({ value: value }));
  }

  public saveSecondOnboardingStep(stepTwoInfo: IOnboardingParams) {
    this._store.dispatch(onboardingActions.saveSecondOnboardingStep({ stepTwoInfo }));
  }

  public setCaptchaDNIForm(token: string) {
    this._store.dispatch(onboardingActions.setCaptchaDNIForm({ token }));
  }

  public setNewOnboardingStep(onboardingStep: number) {
    this._store.dispatch(onboardingActions.setNewOnboardingStep({ step: onboardingStep }));
  }

  public setNextOnboardingStep() {
    this._store.dispatch(onboardingActions.nextOnboardingStep());
  }

  public setPreviousOnboardingStep() {
    this._store.dispatch(onboardingActions.previousOnboardingStep());
  }

  public resetPrecustomerError() {
    this._store.dispatch(onboardingActions.resetPrecustomerError());
  }

  public setIsLoadingOnboarding(isLoading: boolean) {
    this._store.dispatch(onboardingActions.setIsLoadingOnboarding({ isLoading }));
  }

  public setIsPostLoading(isPostLoading: boolean): void {
    this._store.dispatch(onboardingActions.setIsPostLoading({ isPostLoading }));
  }
}
